import {
  getLocationsForPortfolio,
  orEmptyArray,
} from '@lms/api-client/backend';
import useSWR from 'swr';
import { useBrand } from '@/features/branding/brand-provider';
import Stats from '@/features/dashboard/components/main-dashboard';

// Ports app/[brand]/admin/page.tsx: loads the portfolio's locations (empty for
// a location-type site) and renders the main stats dashboard.
export function Dashboard() {
  const { brand: site } = useBrand();
  const { data: locations } = useSWR(
    ['admin/locations-for-portfolio', site.id],
    () => orEmptyArray(getLocationsForPortfolio(site.id)),
  );

  return (
    <div>
      <Stats site={site} locations={locations ?? []} />
    </div>
  );
}
